import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { User } from "../../../models/user.model";
import { ModalService } from "../../../services/modal.service";
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { OTPDialogComponent } from "./otp-dialog/otp-dialog.component";
import {
    FormBuilder,
    FormGroup,
    ValidationErrors,
    Validators,
} from "@angular/forms";

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {
    loading: boolean = false;
    user: User = new User();
    phoneForm!: FormGroup;
    genders = ["male", "female"];
    checked;
    isSubmitted = false;

    constructor(
        private authService: AuthService,
        private modal: ModalService,
        private fb: FormBuilder,

        private router: Router,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
     
         
        this.phoneForm = this.fb.group({
            phone: ["", []],
            dob: [],
            email:[],
            gender: [],
            name: [],
            checked: ["", Validators.required],
        });
      
        const savedData = localStorage.getItem('phoneForm');
        if (savedData) {
          this.phoneForm.patchValue(JSON.parse(savedData));
        }
        this.phoneForm.valueChanges.subscribe((formData) => {
            localStorage.setItem('phoneForm', JSON.stringify(formData));
          });
    }
    getphoneControlErrors(controlName: string): ValidationErrors | null {
        return this.phoneForm.controls[controlName].errors;
    }
 
check(){
    console.log(this.phoneForm.value.checked)
}
    signUp() {
        this.isSubmitted = true;
        let body:any = {};
   
            body = {
                is_email: this.phoneForm.value.phone?0:1, // if 0 => phone, 1=> email
                phone: this.phoneForm.value.phone,
                name: this.phoneForm.value.name,
                gender: +this.phoneForm.value.gender,
                dob: this.phoneForm.value.dob,
                email: this.phoneForm.value.email,

        
        }
        if(this.phoneForm.value.gender == 0){
            delete body.gender
        }
    
        this.loading = true;
        this.authService.register(body).subscribe(
            (res) => {
                this.loading = false;
                console.log(res);
                this.dialog.open(OTPDialogComponent, {
                    panelClass: "confirm-dialog-panel",
                    width: "30vw",
                    disableClose: true,
                    minWidth: "270px",
                    data: {
                        entity:  this.phoneForm.value.phone?'phone':'email',
                    },
                });
                localStorage.removeItem('phoneForm');

            },
            (error) => {
                this.loading = false;
                if (error.status === 404)
                    this.modal.errorMessage(
                        "Something went wrong"
                    );
                else {
                    console.log(error);
                    const allErrors: any[] = Object.values(error.error.errors)
    .flatMap((messages) => messages); // Combines arrays of messages into a single array

// Join the error messages with a line break or custom separator
const errorMessage = allErrors.join(',');

// Show the combined error message in the modal
this.modal.errorMessage(errorMessage);
                    // this.modal.errorMessage(error["error"].message);
                }
            }
        );
    }
}
